import React from "react"
import { ShareMessageFragment } from "~/__generated__/graphql"
import { BadgeSize, UserAvatar } from "~/ui/user-avatar"
import { MessageHeader } from "./message-header"
import { MessageAttachments } from "./message-attachments/message-attachments"
import { QuotedMessage } from "./message-attachments/quoted-message"
import { FormattedAppText } from "~/ui/formatted-app-text"
import { MessageReplies } from "./message-replies"
import { MessageReactions } from "./message-reactions"
interface ChatShareMessageProps {
  message: ShareMessageFragment
  compact?: boolean
}

export const ChatShareMessage: React.FC<ChatShareMessageProps> = ({
  message,
  compact = false,
}: ChatShareMessageProps) => {
  const user = message.user
  const displayName = user?.displayOrUsername || "User"
  const hasAttachments = message.attachments?.length > 0

  return (
    <div className="flex flex-col gap-4">
      <div className="flex w-fit flex-row items-center gap-2">
        <UserAvatar
          avatarUrl={user?.avatarUrl}
          displayName={displayName}
          size={compact ? "xsm-sm" : "sm"}
        />
        <MessageHeader
          showVerified={user?.verifiedAccount}
          displayName={displayName}
          textVariant={compact ? "hairline-2" : "hairline-1"}
          badgeSize={compact ? BadgeSize.sm : BadgeSize.md}
        />
      </div>
      <div className="flex flex-col gap-3">
        {!!message.quotedMessage && (
          <div className="flex flex-col gap-2">
            <QuotedMessage quotedMessage={message.quotedMessage} />
          </div>
        )}
        {message?.textContent && (
          <FormattedAppText
            text={message.textContent}
            variant={compact ? "body2" : "body1-medium"}
            className={hasAttachments ? "line-clamp-2" : "line-clamp-10"}
          />
        )}
        {hasAttachments && (
          <div className="flex items-center justify-center">
            <MessageAttachments attachments={message.attachments} />
          </div>
        )}
      </div>
      {(message.childMessagesCount > 0 || message.reactionGroups?.length > 0) && (
        <div className="flex flex-wrap gap-1">
          {message.childMessagesCount > 0 && message.childMessageUsers && (
            <MessageReplies
              childMessagesCount={message.childMessagesCount}
              childMessageUsers={message.childMessageUsers}
            />
          )}

          <MessageReactions reactionGroups={message.reactionGroups} />
        </div>
      )}
    </div>
  )
}

export default ChatShareMessage
